'use client';

import Image from 'next/image';
import { useRouter } from 'next/navigation';

import { IoIosArrowBack } from 'react-icons/io';

import Login from '@/features/v2/common/login/Login';
import { core } from '@/features/v2/common/login/localization/core';

import { Lightning } from '@/components/ui/backgrounds/Lightning';

import { routes } from '../../constants/routes';

const WraperLogin = () => {
  const router = useRouter();
  return (
    <main className="flex flex-col items-center justify-center h-screen relative bg-hbackground overflow-hidden">
      <div className="absolute inset-0 z-0 opacity-80">
        <Lightning
          hue={270}
          xOffset={0}
          speed={0.5}
          intensity={0.5}
          size={1.2}
        />
      </div>
      <button type="button" aria-label={core.backHome} className="text-2xl absolute left-4 top-6 border border-default-900 rounded-full p-2 z-50" onClick={() => { router.push(routes.HOME); }}>
        <IoIosArrowBack size={24} aria-hidden />
      </button>
      <Image
        src="/img/logo/LogoDesktop.svg"
        alt="Powerbet"
        width={224}
        height={48}
        className="absolute top-5 left-1/2 -translate-x-1/2 w-56! h-12! z-10"
      />
      <Login />
    </main>
  );
};

export default WraperLogin;
